module.exports = __webpack_public_path__ + "static/media/stelian.fea41c29.jpeg";